/**
 * Returns a human-readable reading time string.
 * Example: 5 → "5 min read"
 */
export function formatReadingTime(minutes: number): string {
  if (minutes < 1) return '< 1 min read'
  return `${minutes} min read`
}

/**
 * Estimates reading time from raw text (200 wpm average).
 */
export function estimateReadingTime(text: string): number {
  const words = text.trim().split(/\s+/).length
  return Math.max(1, Math.ceil(words / 200))
}
